import { z } from "zod";
import { type ParserType, parser } from "./parser.js";

export type AuthenticationError = ParserType<typeof AuthenticationError>;
export const AuthenticationError = parser(
  z.strictObject({
    error: z.string(),
  }),
);
